import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Theme } from '@astryxdesign/core/theme';
import { FullPageError } from '@/components/StateViews';
import { fallbackTheme } from '@/features/tenant/theme';
import { useThemeMode } from '@/features/theme/mode';
import { hideBootSplash } from '@/lib/boot';

export function NotFoundPage() {
  useEffect(hideBootSplash, []);
  const { mode } = useThemeMode();
  return (
    <Theme theme={fallbackTheme} mode={mode}>
      <FullPageError title="Страница не найдена" description="Проверьте ссылку или вернитесь на главную студии." />
    </Theme>
  );
}

export function NoTenantPage() {
  useEffect(hideBootSplash, []);
  const { mode } = useThemeMode();
  return (
    <Theme theme={fallbackTheme} mode={mode}>
      <FullPageError title="Откройте ссылку студии" description="Адрес записи выглядит так: /s/название-студии/" />
    </Theme>
  );
}

export function RootErrorPage() {
  const err = useRouteError();
  useEffect(hideBootSplash, []);
  const { mode } = useThemeMode();
  const description = isRouteErrorResponse(err) ? `${err.status} ${err.statusText}` : err instanceof Error ? err.message : undefined;
  return (
    <Theme theme={fallbackTheme} mode={mode}>
      <FullPageError title="Что-то пошло не так" description={description} onRetry={() => window.location.reload()} />
    </Theme>
  );
}
